const state = {
    leaverequests: [],
    leaverequestId: [],
    employee: [],
    subordinate: [],
    loading: false
};

export default state;